import React from "react";

import GiftCardRedeemForm from "./components/GiftCardRedeemForm";

const GiftCardRedeemApp = (props) => <GiftCardRedeemForm {...props} />;

export default GiftCardRedeemApp;
